import React from "react";
import { FormControl, TextField, Autocomplete, Checkbox, ListItemText, Chip } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

const filterOptions = createFilterOptions({ matchFrom: 'start' });

// Same closed-box look/footprint as DropdownTableInput (width 200, no floating
// label, displayEmpty-style placeholder), but backed by an Autocomplete so a
// table cell can search/filter and select multiple options (e.g. Marketer).
// The dropdown menu is widened beyond the closed box so long option labels
// aren't clipped.
const MultiSelectTableInput = ({ label, value, onChange, options, disabled }) => {
    const selectedValues = Array.isArray(value) ? value : [];
    const selectedOptions = options.filter((option) => selectedValues.includes(option.value));

    return (
        <FormControl sx={{ width: 200 }}>
            <Autocomplete
                multiple
                disableCloseOnSelect
                disabled={disabled || undefined}
                options={options}
                value={selectedOptions}
                onChange={(event, newValue) => onChange(newValue.map((option) => option.value))}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, val) => option.value === val.value}
                filterOptions={filterOptions}
                slotProps={{
                    popper: { style: { width: 'auto' } },
                    paper: { sx: { minWidth: 350 } },
                }}
                renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                        <Checkbox checked={selectedValues.includes(option.value)} />
                        <ListItemText primary={option.label} />
                    </li>
                )}
                renderTags={(tagValue) => {
                    if (tagValue.length > 1) {
                        return <Chip label={`${tagValue.length} options selected`} />;
                    }
                    return tagValue.map((option) => option.label).join(', ');
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={selectedValues.length === 0 ? label : undefined}
                    />
                )}
            />
        </FormControl>
    )
}

export default MultiSelectTableInput;
